import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "mx-autor px-4 py-28"
}
const _hoisted_3 = { class: "flex justify-center mb-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-2xl text-center mb-4" }, "Last step :)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-4 text-gray-description" }, [
  /*#__PURE__*/_createTextVNode(" The following amount of complimentary Carbon NFTs and Life NFTs will be sent to the "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" account/wallet address below. ")
], -1)
const _hoisted_6 = { class: "text-gray-description text-center" }
const _hoisted_7 = { class: "text-gray-description text-center mb-4" }
const _hoisted_8 = { class: "flex text-center mb-8" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-description" }, "Account/wallet address : ", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_11 = { class: "flex justify-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Confirm ")
const _hoisted_14 = {
  key: 1,
  class: "mx-autor px-4 py-28"
}
const _hoisted_15 = { class: "flex justify-center mb-8" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-2xl font-semibold mb-4" }, " Your session has expired ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-gray-description mb-8" }, " Please receive NFTs again to continue working. ", -1)
const _hoisted_18 = { class: "flex justify-center" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Receive NFTs ")
const _hoisted_20 = {
  key: 2,
  class: "mx-autor px-4 py-28"
}
const _hoisted_21 = { class: "flex justify-center mb-8" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-2xl font-semibold mb-4" }, " It’s done. The NFTs have been sent :) ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-gray-description mb-8" }, " Note: It may takes up to 15 minutes before the NFTs amount gets updated in your account/wallet. ", -1)
const _hoisted_24 = { class: "flex justify-center" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Back to Home ")

import { defineComponent, onMounted, computed, ref } from 'vue';
import IconConfirmReceive from '@/components/Icons/IconConfirmReceive.vue';
import IconExpireSession from '@/components/Icons/IconExpireSession.vue';
import IconReceiveDone from '@/components/Icons/IconReceiveDone.vue';
import { useRoute } from 'vue-router';
import * as apis from '@/apis';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const expired = ref<boolean>(false);
const stepConfirm = ref<boolean>(false);
const amount = ref<number>(0);
const recipient = ref();
const token = ref<string>('');
const isConfirmFronEmail = computed(() => {
  return route.name === 'ConfirmReceive';
});

onMounted(async () => {
  if (isConfirmFronEmail.value) {
    token.value = decodeURIComponent(
      escape(window.atob(route.params.id as string))
    );
    try {
      const infoClaim = await apis.getInfoReceiveNfts({
        params: {
          token: token.value,
        },
      });
      amount.value = infoClaim.data.payment.amount;
      recipient.value = infoClaim.data.recipient;
    } catch (error) {
      expired.value = true;
    }
  } else {
    stepConfirm.value = true;
  }
});

const confirm = async () => {
  try {
    await apis.receiveConfirm({
      token: token.value,
    });
    stepConfirm.value = true;
  } catch (error) {
    console.error(error);
  }
};
defineComponent({
  name: 'ConfirmReceiveView',
});

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isConfirmFronEmail) && !stepConfirm.value && !expired.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(IconConfirmReceive)
          ]),
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, " Carbon NFTs : " + _toDisplayString(amount.value), 1),
          _createElementVNode("div", _hoisted_7, " Life NFTs : " + _toDisplayString(amount.value), 1),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(recipient.value), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, { to: "/landing" }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, {
                  class: "border mr-6",
                  "color-scheme": "white",
                  height: "44px",
                  secondary: "",
                  "data-testid": "cancel-receive-btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_BaseButton, {
              "color-scheme": "primary",
              height: "44px",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (confirm())),
              "data-testid": "confirm-receive-btn"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (expired.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(IconExpireSession)
          ]),
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_router_link, { to: "/landing/receive-nft" }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, {
                  "color-scheme": "primary",
                  height: "44px",
                  "data-testid": "receive-btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (stepConfirm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(IconReceiveDone)
          ]),
          _hoisted_22,
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_router_link, { to: "/landing" }, {
              default: _withCtx(() => [
                _createVNode(_component_BaseButton, {
                  "color-scheme": "primary",
                  height: "44px",
                  "data-testid": "back-to-home-btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})